import { Helmet } from 'react-helmet-async';

import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';

// @mui
import { Box, CircularProgress, Container, Grid, Paper, Typography } from '@mui/material';
import Alert from '@mui/material/Alert';
import Snackbar from '@mui/material/Snackbar';
import PropTypes from 'prop-types';

import { GetClient } from 'src/components/services/httpServices';

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`full-width-tabpanel-${index}`}
      aria-labelledby={`full-width-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}
function a11yProps(index) {
  return {
    id: `full-width-tab-${index}`,
    'aria-controls': `full-width-tabpanel-${index}`,
  };
}
TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};
export default function ClientDetails() {
  let { id } = useParams();

  const [client, setClient] = useState({});
  const [vertical, setVertical] = useState('bottom');
  const [horizontal, setHorizontal] = useState('right');
  const [open, setOpen] = useState(false);
  const [saved, setSaved] = useState(false);
  const [loading, setLoading] = useState(true);
  const [message, setMessage] = useState('sdsdsdsds');

  const fetchClient = async (event) => {
    const client = await GetClient(id);

    setClient(client);
    setLoading(false);
  };
  useEffect(() => {
    fetchClient();
  }, []);

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <>
      <Helmet>
        <title> Client | Immigration System </title>
      </Helmet>
      <Container>
        {loading ? (
          <Grid display="flex" alignItems="center" justifyContent="center" height="40vh" container>
            <CircularProgress size={60} thickness={3} value={100} />
          </Grid>
        ) : (
          <>
            <Box
              p={4}
              marginBottom={4}
              component={Paper}
              boxShadow={3}
              sx={{ border: 0, borderColor: 'primary.main', borderRadius: '16px' }}
            >
              <Grid container spacing={3}>
                <Grid item xs={6} sm={3} md={3}>
                  <Typography variant="h6" color="initial">
                    Full Name :{' '}
                  </Typography>
                  <Typography variant="subtitle" color="initial">
                    {client?.fullName}
                  </Typography>
                </Grid>
                <Grid item xs={6} sm={3} md={3}>
                  <Typography variant="h6" color="initial">
                    Passport No :{' '}
                  </Typography>
                  <Typography variant="subtitle" color="initial">
                    {client?.passportNo}
                  </Typography>
                </Grid>
                <Grid item xs={6} sm={3} md={3}>
                  <Typography variant="h6" color="initial">
                    Passport Expiry :{' '}
                  </Typography>
                  <Typography variant="subtitle" color="initial">
                    {client?.expiryDate?.split('T')[0]}
                  </Typography>
                </Grid>
                <Grid item xs={6} sm={3} md={3}>
                  <Typography variant="h6" color="initial">
                    Contact:{' '}
                  </Typography>
                  <Typography variant="subtitle" color="initial">
                    {client?.phoneNumber}
                  </Typography>
                </Grid>
                <Grid item xs={6} sm={3} md={3}>
                  <Typography variant="h6" color="initial">
                    Alternate Contact:{' '}
                  </Typography>
                  <Typography variant="subtitle" color="initial">
                    {client?.altCntctNum}
                  </Typography>
                </Grid>
                <Grid item xs={6} sm={3} md={3}>
                  <Typography variant="h6" color="initial">
                    Email:{' '}
                  </Typography>
                  <Typography variant="subtitle" color="initial">
                    {client?.email}
                  </Typography>
                </Grid>
                <Grid item xs={6} sm={3} md={3}>
                  <Typography variant="h6" color="initial">
                    Resident Address:{' '}
                  </Typography>
                  <Typography variant="subtitle" color="initial">
                    {client?.residentAddress}
                  </Typography>
                </Grid>
                <Grid item xs={6} sm={3} md={3}>
                  <Typography variant="h6" color="initial">
                    Date of Birth:{' '}
                  </Typography>
                  <Typography variant="subtitle" color="initial">
                    {client?.dateOfBirth?.split('T')[0]}
                  </Typography>
                </Grid>
                <Grid item xs={6} sm={3} md={3}>
                  <Typography variant="h6" color="initial">
                    Place of Birth:{' '}
                  </Typography>
                  <Typography variant="subtitle" color="initial">
                    {client?.placeOfBirth}
                  </Typography>
                </Grid>
                <Grid item xs={6} sm={3} md={3}>
                  <Typography variant="h6" color="initial">
                    Citizenship:{' '}
                  </Typography>
                  <Typography variant="subtitle" color="initial">
                    {client?.citizenship}
                  </Typography>
                </Grid>
                <Grid item xs={6} sm={3} md={3}>
                  <Typography variant="h6" color="initial">
                    Current Country:{' '}
                  </Typography>
                  <Typography variant="subtitle" color="initial">
                    {client?.currentCountry}
                  </Typography>
                </Grid>
                <Grid item xs={6} sm={3} md={3}>
                  <Typography variant="h6" color="initial">
                    Martial Status:{' '}
                  </Typography>
                  <Typography variant="subtitle" color="initial">
                    {client?.martialStatus}
                  </Typography>
                </Grid>
                <Grid item xs={6} sm={3} md={3}>
                  <Typography variant="h6" color="initial">
                    Client Type:{' '}
                  </Typography>
                  <Typography variant="subtitle" color="initial">
                    {client?.clientType}
                  </Typography>
                </Grid>
                <Grid item xs={6} sm={3} md={3}>
                  <Typography variant="h6" color="initial">
                    Application Type:{' '}
                  </Typography>
                  <Typography variant="subtitle" color="initial">
                    {client?.applicationType}
                  </Typography>
                </Grid>
                <Grid item xs={6} sm={3} md={3}>
                  <Typography variant="h6" color="initial">
                    Status:{' '}
                  </Typography>
                  <Typography variant="subtitle" color="initial">
                    {client?.status}
                  </Typography>
                </Grid>
              </Grid>
            </Box>
          </>
        )}
      </Container>
      {saved ? (
        <Snackbar
          anchorOrigin={{ vertical, horizontal }}
          key={vertical + horizontal}
          open={open}
          autoHideDuration={4000}
          onClose={handleClose}
        >
          <Alert elevation={6} variant="filled" onClose={handleClose} severity="success">
            {message}
          </Alert>
        </Snackbar>
      ) : (
        <Snackbar
          key={vertical + horizontal}
          anchorOrigin={{ vertical, horizontal }}
          open={open}
          autoHideDuration={4000}
          onClose={handleClose}
        >
          <Alert elevation={6} variant="filled" onClose={handleClose} severity="error">
            {message}
          </Alert>
        </Snackbar>
      )}
    </>
  );
}
